<template>
    <div class="inputs inputs--budget-check">
        <p>Pour savoir si votre budget est suffisant merci de renseigner les champs budget et CA prévisionnel</p>
        <form @submit.prevent="onSubmit">
            <div class="row">
                <div class="form-group col-xs-6">
                    <label for="ca-input">CA previsionnel</label>
                    <div class="input-group">
                        <input type="number" id="ca-input" name="ca" class="form-control" @focus="isWrongClass = false" v-model="ca" :class="{'is-wrong': isWrongClass}">
                        <div class="input-group-addon">€</div>
                    </div>
                </div>
                <div class="form-group col-xs-6">
                    <label for="budget-input">Budget estimé</label>
                    <div class="input-group">
                        <input type="number" id="budget-input" name="budget" class="form-control" @focus="isWrongClass = false" v-model="budget" :class="{'is-wrong': isWrongClass}">
                        <div class="input-group-addon">€</div>
                    </div>
                </div>
            </div>
            <!--il est important de mettre un input type="submit" et non un button type="submit"
            sans quoi le submit ne s'effectuera pas sous ios
            http://stackoverflow.com/questions/5665203/getting-iphone-go-button-to-submit-form -->
            <input type="submit" class="btn btn-lg btn-primary" @click.prevent="onSubmit" value="Je vérifie"></input>
        </form>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                ca: '',
                budget: '',
                analyse: '',
                isWrongClass: false,
            }
        },
        methods: {
            onSubmit() {
                //les 2 champs doivent être renseigné
                if(this.ca && this.budget) {

                    //calcule du pourcentage à 2 décimales apres la virgule
                    let percentage = Math.round( ((this.budget / this.ca) * 100) * 100 ) / 100;

                    if(percentage < 4) {
                        this.$store.state.budget.analyse = "Votre budget estimé est insuffisant. Le bon ratio se situe entre 4 et 6% de votre CA prévisionnel. Vous pouvez aller au delà de 6% en cas de lancement.";
                        this.$store.state.budget.analyseClass = "is-not-enough"
                    } else if(percentage >= 4 && percentage < 8) {
                        this.$store.state.budget.analyse = "Votre budget estimé est correct. Vous pouvez cependant l'augmenter en cas de lancement";
                        this.$store.state.budget.analyseClass = ""
                    } else if(percentage >= 8) {
                        this.$store.state.budget.analyse = "Votre budget est trop important, il est inutile qu'il soit supérieur à 8% excepté en cas de lancement";
                        this.$store.state.budget.analyseClass = "is-too-much"
                    }

                    this.$store.state.budget.result = percentage;
                    //on indique la partie dans la vue resultat a afficher
                    this.$store.state.budget.showResultPart = "check";

                    this.$store.commit('showBudgetResult');
                    //on force la fermeture du keyboard pour IOS en desactivant le focus
                    document.activeElement.blur();
                } else {
                    this.isWrongClass = true;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// BudgetCheck.vue?68662776